// Improvement Clarification list: status tones, filter options and the
// Excel/CSV export. Download helpers are shared with the Plan & Procurement
// list.

import { downloadSheet } from '../../Procurement/utils/procurementList';
import {
  CLARIFICATION_STATUS_META,
  IMPROVEMENT_STATUS_META,
} from './improvementClarificationHelpers';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const IMPROVEMENT_STATUS_OPTIONS = ['Open', 'Closing', 'Submitted'];

export const CLARIFICATION_STATUS_OPTIONS = [
  'Open',
  'Waiting Response from Registered Supplier',
  'Waiting Response from Panitia Tender',
  'Closing',
];

// The status meta maps use Bootstrap colours; the to-status modifiers are
// named by tone. Unknown wordings were grey before.
const COLOR_TO_TONE = {
  primary: 'info',
  success: 'success',
  danger: 'danger',
  warning: 'warning',
  secondary: 'muted',
};

export const getImprovementTone = wording =>
  COLOR_TO_TONE[IMPROVEMENT_STATUS_META[wording]?.color || 'secondary'];

export const getClarificationTone = wording =>
  COLOR_TO_TONE[CLARIFICATION_STATUS_META[wording]?.color || 'secondary'];

// The detail page reads these from router state.
export const getDetailState = row => ({
  statusImprovement: row.statusImprovement,
  statusClarification: row.statusClarification,
  statusClarificationProgress: row.statusClarificationProgress,
  procurementMitraId: row.procurementMitraId,
  idOffer: row.idOffer,
});

const toExportRow = row => ({
  'ID Proc': row.idProc || '',
  Title: row.title || '',
  'Proc Type': row.procType || '',
  Product: row.productType?.product?.name || row.productType?.name || '',
  'Product Type': getListProductTypeLabel(row, row.productType?.name) || '',
  Description: row.description || '',
  'Status Improvement': row.statusImprovement || '',
  'Status Clarification': row.statusClarification || '',
});

export const exportImprovementClarificationList = (rows, opts) =>
  downloadSheet(rows.map(toExportRow), {
    ...opts,
    prefix: 'ImprovementClarification',
  });
